export default {
    state: {
        all: [],
        filtered: []
    },
};